import React from 'react'
// import InfoShape from './InfoShape'
import CompanyHeader from '../vara-haften/CompanyHeader'
import CompanyModalCoupon from '../vara-haften/CompanyModalCoupon'
// import { useAutosize } from '../../common/Helpers'

const { REACT_APP_IMAGE_BASE_URL } = process.env;

const CompanyReviewCoupons = ({ companyReviewData, companyTypesData, booklet }) => {
  // const { width } = useAutosize();
  // const isDesktop = width > 992;

  const validTo = new Date(booklet?.validTo).toLocaleDateString('sv-SE', { day: 'numeric', month: 'numeric' }) || '';

  return (
    <div className="company-review-booklet box flex flex-col items-center">
      {booklet &&
        <div className="company-review-booklet-header relative flex flex-col items-center">
          <div className='booklet-bg left' style={{ backgroundColor: booklet?.colorLeft }} />
          <div className='booklet-bg right' style={{ backgroundColor: booklet?.colorRight }} />
          <img src={REACT_APP_IMAGE_BASE_URL + booklet?.logoURL} alt={booklet?.title} />
          <h3 style={{ color: booklet?.colorFont || '#fff' }}>{booklet?.title}</h3>
          <small style={{ color: booklet?.colorFont || '#fff' }}>Giltigt t.o.m {validTo}</small>
        </div>
      }
      <div className="relative company-review-coupons box">
        <CompanyHeader
          company={companyReviewData?.bookletCompanyReviewByToken?.company}
          companyType={companyTypesData?.types[companyReviewData?.bookletCompanyReviewByToken?.company?.typeId]}
        />
        {companyReviewData?.bookletCompanyReviewByToken?.coupons.map(coupon =>
          <CompanyModalCoupon
            key={coupon._id}
            coupon={coupon}
            booklet={booklet}
          />
        )}
      </div>
      {/* <InfoShape
        isArrowReversed={isDesktop}
        rotate={!isDesktop ? 90 : 0}
        title='Såhär ser det ut när man klickat in på ert företag'
        color='#368181'
        height={160}
        width={160}
        x={isDesktop ? 370 : '29%'}
        y={isDesktop ? -50 : -155}
        arrowX={isDesktop ? '10%' : '-30%'}
        arrowY={isDesktop ? 130 : '50%'}
      /> */}
    </div>
  )
}

export default CompanyReviewCoupons
